"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginAsAdminId = exports.getUserAvatar = exports.getUserEmail = exports.getCanUseChromeExtension = exports.getAuthAbilities = exports.getUserRoles = exports.getUserFullName = exports.getUserName = exports.getError = exports.getIsLoading = exports.getIsAuthenticated = void 0;

var _ramda = require("ramda");

var _reselect = require("reselect");

var getAuthState = function getAuthState(state) {
  return state.auth;
};

var getIsAuthenticated = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.authenticated;
});
exports.getIsAuthenticated = getIsAuthenticated;
var getIsLoading = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.loading;
});
exports.getIsLoading = getIsLoading;
var getError = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.error || '';
});
exports.getError = getError;
var getUserName = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.userInfo.userName;
});
exports.getUserName = getUserName;
var getUserFullName = (0, _ramda.pipe)(getAuthState, function (_ref) {
  var _ref$userInfo = _ref.userInfo,
      firstName = _ref$userInfo.firstName,
      lastName = _ref$userInfo.lastName;
  return lastName ? "".concat(firstName, " ").concat(lastName) : firstName;
});
exports.getUserFullName = getUserFullName;
var getUserRoles = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.userInfo.roles || [];
});
exports.getUserRoles = getUserRoles;
var getAuthAbilities = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.userInfo.permissions || [];
});
exports.getAuthAbilities = getAuthAbilities;
var getCanUseChromeExtension = (0, _reselect.createSelector)(getAuthAbilities, function (permissions) {
  return permissions.includes('can_use_chrome_extension');
});
exports.getCanUseChromeExtension = getCanUseChromeExtension;
var getUserEmail = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.userInfo.email || '';
});
exports.getUserEmail = getUserEmail;
var getUserAvatar = (0, _ramda.pipe)(getAuthState, function (state) {
  return state.userInfo.image;
});
exports.getUserAvatar = getUserAvatar;
var getLoginAsAdminId = (0, _ramda.pipe)(function (state) {
  return state === null || state === void 0 ? void 0 : state.auth;
}, function (state) {
  var _state$userInfo$admin, _state$userInfo;

  return (_state$userInfo$admin = state === null || state === void 0 ? void 0 : (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.adminId) !== null && _state$userInfo$admin !== void 0 ? _state$userInfo$admin : null;
});
exports.getLoginAsAdminId = getLoginAsAdminId;